/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum ConsentStatus {
    Approved = 'Approved',
    WaitingForApproval = 'Waiting for approval',
    NotApproved = 'Not approved'
}

export function ConsentStatusFromJSON(json: any): ConsentStatus {
    return ConsentStatusFromJSONTyped(json, false);
}

export function ConsentStatusFromJSONTyped(json: any, _: boolean): ConsentStatus {
    return json as ConsentStatus;
}

export function ConsentStatusToJSON(value?: ConsentStatus | null): any {
    return value as any;
}
